var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isYouTubeSource)?_c('iframe',{attrs:{"width":_vm.width,"height":_vm.height,"src":_vm.youTubeSource,"allowFullScreen":""}}):_c('video',{ref:"videoPlayer",staticClass:"video-js"})])
}
var staticRenderFns = []

export { render, staticRenderFns }